__turbopack_context__.v({
  "chevron": "SettingsNav-module__jIqkRq__chevron",
  "link": "SettingsNav-module__jIqkRq__link",
  "linkInner": "SettingsNav-module__jIqkRq__linkInner",
});
